import React from "react";
export default function ContentField({ content }) {
  return /* @__PURE__ */ React.createElement("div", { className: "form-input form-input--content" }, content);
}
